import ArticleItem from './ArticleItem'

export default function ArticleList(props) {
    return(
        <>
            {props.articles.map(article => (<ArticleItem key={article.id} article={article} pubProfileToggle={props.pubProfileToggle} />))}
        </>
    )
}